import React, { useEffect } from 'react';
import './HP.css';

export default function HPHeader({ createCall, startHairCheck }) {
  return (
    <div id="hp-header">
      <div id="hp-logo">
        <a href="./">
          <img src="./images/hp/logowithicon.svg" />
        </a>
      </div>
      <div id="hp-header-right">
        <div className="hp-header-item">About</div>
        <div className="hp-header-item">Price</div>
        <div className="hp-header-item">
          <a href="./faq">FAQ</a>
        </div>
        <div className="hp-header-item">
          <button>Download Now</button>
        </div>
      </div>
    </div>
  );
}
